import axios from "axios";
import { RefineVisualisationUpload, VisualisationUpload } from "../entities/entities";
import i18n from "../i18n";
import { axiosInstance } from "../App";

export async function getVisualisation(payload: VisualisationUpload):Promise<any> {
    const body = {
      filename: payload.filename,
      goal:payload.goal,
      library: payload.library,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-4",
        max_tokens: null,
        provider: "openai",
      },
    };
    return axiosInstance
      .post(process.env.REACT_APP_API_HOST + "visualize_user_data", body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        // return status code
        return {status: error.response.status};
      });
  }

  export async function getRefineVisualisation(payload: RefineVisualisationUpload):Promise<any> {
    const body = {
      filename: payload.filename,
      library: payload.library,
      goal:payload.goal,
      code: payload.code,
    instructions: payload.instructions,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-4",
        max_tokens: null,
        provider: "openai",
      },
    };
    return axiosInstance
      .post(process.env.REACT_APP_API_HOST + "visualize_user_data/edit", body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        return {status: error.response.status};
      });
  }
